<template>
    <div class="protector-component">
        <Loader />
    </div>
</template>

<script>
import Component from "vue-class-component";
import Loader from "./Loader";
import Vue from "vue";

@Component({
    components: { Loader }
})
class Protector extends Vue {

}

export default Protector;
</script>

<style scoped lang="scss">
    @import '../../custom1';

    .protector-component {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99999;
        background-color: rgba( $bg-color, .5 );
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>